import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { newDefinitionId } from '../types';
import { EditorModal } from './EditorModal';
import { Spacer } from './editorStyles';
import { Action, Field, FormSection, Hint } from './styles';
import type { OverviewEditor } from './useOverviewEditor';

/** Adds a question that is not in the report yet. Swapping a placed question is done by removing and adding. */
export function QuestionModal({
  editor,
  index,
  onClose,
}: {
  editor: OverviewEditor;
  index: number;
  onClose: () => void;
}) {
  const { t } = useTranslation('newReport');
  const options = editor.unplacedQuestions;
  const [questionIndex, setQuestionIndex] = useState(options[0]?.index ?? '');
  const [statementIndex, setStatementIndex] = useState<number>();
  const question = options.find((item) => item.index === questionIndex);
  return (
    <EditorModal
      title={t('definition.addQuestion')}
      onClose={onClose}
      footer={
        <>
          <Spacer />
          <Action onClick={onClose}>{t('definition.cancel')}</Action>
          <Action
            primary
            disabled={!question}
            onClick={() => {
              editor.insertAt(
                { id: newDefinitionId(), type: 'question', questionIndex, statementIndex, width: 'full' },
                index,
              );
              onClose();
            }}
          >
            {t('definition.addQuestion')}
          </Action>
        </>
      }
    >
      <FormSection style={{ padding: 0, border: 0 }}>
        <Hint>{t('definition.addQuestionHelp')}</Hint>
        <Field>
          {t('definition.question')}
          <select
            value={questionIndex}
            onChange={(event) => {
              setQuestionIndex(event.target.value);
              setStatementIndex(undefined);
            }}
          >
            {options.map((item) => (
              <option key={item.index} value={item.index}>
                {item.text}
              </option>
            ))}
          </select>
        </Field>
        {!!question?.statementsLocal?.length && (
          <Field>
            {t('tableTest.statement')}
            <select
              value={statementIndex ?? ''}
              onChange={(event) =>
                setStatementIndex(event.target.value === '' ? undefined : Number(event.target.value))
              }
            >
              <option value="">{t('tableTest.wholeQuestion')}</option>
              {question.statementsLocal.map((label, i) => (
                <option key={i} value={i}>
                  {label}
                </option>
              ))}
            </select>
          </Field>
        )}
      </FormSection>
    </EditorModal>
  );
}
